// extracted by mini-css-extract-plugin
export var brand = "_75-9";
export var compact = "_75-6";
export var extraSmall = "_75-7";
export var icon = "_75-0";
export var large = "_75-4";
export var light = "_75-1";
export var medium = "_75-5";
export var outline = "_75-b";
export var primaryDark = "_75-a";
export var primaryLight = "_75-8";
export var primaryModern = "_75-c";
export var success = "_75-2";
export var successSolid = "_75-3";